import React from "react";
import { FC } from "react";

export interface CommonLayoutProps {
  children?: React.ReactNode;
  packageId?: string;
  activeTab?: string;
  onTabChange?: (tab: string) => void;
  widePage?: boolean;
}

const CommonLayout: FC<CommonLayoutProps> = ({
  children,
  packageId,
  activeTab,
  onTabChange,
  widePage = false
}) => {
  const tabs = [
    {
      id: "basic-info",
      label: "Info di base",
    },
    {
      id: "content",
      label: "Contenuto",
    },
    {
      id: "media",
      label: "Media",
    },
  ];

  const handleTabClick = (tabId: string) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <div className="nc-CommonLayoutHolidayPackage bg-neutral-50 dark:bg-neutral-900">
      {/* Tab Navigation */}
      <div className="border-b border-neutral-200 dark:border-neutral-700 pt-12 bg-white dark:bg-neutral-800 sticky top-0 z-10">
        <div className="container">
          <div className="flex space-x-2 md:space-x-8 overflow-x-auto hiddenScrollbar">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;

              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`px-1 py-5 md:py-8 border-b-2 flex-shrink-0 transition-colors ${!isActive
                    ? "border-transparent text-neutral-600 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-neutral-200"
                    : "border-primary-500 text-primary-600 dark:text-primary-400"
                    }`}
                >
                  <span className="text-sm md:text-base font-medium whitespace-nowrap">
                    {tab.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className={`${widePage ? "w-full" : "container"} pt-14 sm:pt-20 pb-24 lg:pb-32`}>
        <div className={widePage ? "w-full px-4" : "max-w-4xl mx-auto"}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default CommonLayout;